import { EventDto } from "@core/models/planner-models/event.dto";
import { ScheduleAbsenceDto } from "@core/models/scheduling/schedule-absence.dto";
export type AbsenceSourceType = 'ScheduledAbsence' | 'CalendarEvent';
export interface AbsenceModel {
    title: string;
    typeTitle: string;
    objectName: string;
    dateFrom: Date;
    dateTo?: Date;
    sourceType: AbsenceSourceType,
}

export function mapScheduleAbsenceDtoToModel(absence: ScheduleAbsenceDto, objectName = '', scheduleType = ''): AbsenceModel {
    return {
        dateFrom: absence.DateStart,
        dateTo: absence.DateEnd,
        title: absence.Description,
        typeTitle: absence.ScheduleType ? absence.ScheduleType : scheduleType,
        objectName: absence.ObjectName ? absence.ObjectName : objectName,
        sourceType: 'ScheduledAbsence'
    }
}

export function mapCalendarEventDtoToModel(event: EventDto, vehicleName: string): AbsenceModel {
    return {
        dateFrom: event.EventDate,
        dateTo: undefined,
        title: event.Title,
        typeTitle: event.Type.Title,
        objectName: vehicleName,
        sourceType: 'CalendarEvent'
    }
}